import { TranslateService } from '@ngx-translate/core';
import { enumErpIntegrado } from 'src/app/classes/Empresa';
import { EmpresaService } from 'src/app/services/empresa.service';
import { StorageService } from 'src/app/services/storage.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Usuario } from 'src/app/classes/Usuario';
import { UsuarioService } from 'src/app/services/usuario.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { MasksService } from 'src/app/utils/masks.service';
import { UtilsService } from 'src/app/utils/utils.service';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import { UsuarioFormComponent } from './usuario-form/usuario-form.component';
import { PermissaoUsuario } from 'src/app/classes/PermissaoUsuario';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';
import { PermissaoUsuarioTransacao } from 'src/app/classes/PermissaoUsuarioTransacao';
import { ColDef } from 'src/app/classes/grid/ColDef';
import { ColumnModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import moment from 'moment';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.scss']
})
export class UsuarioComponent implements OnInit {
  @ViewChild('ModalCopiaPermissao', { static: false })
  ModalCopiaPermissao: UiModalComponent;
  @ViewChild('ModalCopiaPermissaoTransacao', { static: false })
  ModalCopiaPermissaoTransacao: UiModalComponent;
  @ViewChild('gridUsuarios', { static: false }) gridUsuarios: SyncGridComponent;
  usuarios: Usuario[];
  id: number = 0;
  inserindo: boolean = false;
  carregando: boolean = false;
  objSelecionado: Usuario = new Usuario();
  objSelecionadoId: number = null;
  objetosSelecionados: Usuario[] = [];
  selectedId: number = 0;
  isSubmit: boolean = false;
  gridHeight: string = '79vh';


  gridPageSettings: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20, // padrão alterado para 20
    pageCount: 4
  };
  desabilitarAcoes: boolean = false;
  removendo: boolean = false;
  inativando: boolean = false;
  duplicando: boolean = false;
  textoBusca: string = "";
  auxUsuarios: Usuario[] = [];

  colDefs: ColDef[] = [
    {
      width: 45,
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    { field: 'Nome', headerName: 'Nome' },
    { field: 'Email', headerName: 'E-mail' },
    { field: 'Telefone', headerName: 'Telefone' },
    { field: 'Login', headerName: 'Login' },
    { field: 'Perfil', headerName: 'Perfil', valueFormatter: (params) => params.data.Perfil == 1 ? 'Super' : params.data.Perfil == 2 ? 'Administrador' : 'Usuário' },
    { field: 'Ativo', headerName: 'Status', width: 70, cellRenderer: (params) => params.data.Ativo ? `<span class="badge badge-light-success custom-badge-grid">Ativo</span>` : `<span class="badge badge-light-danger custom-badge-grid">Inativo</span>` }
  ];

  talhoesColumns: ColumnModel[] = [
    { type: "checkbox", width: 50 },
    { field: 'Nome', headerText: 'Nome', allowSorting: true, width: 200 },
    { field: 'Email', headerText: 'E-mail', allowSorting: true, width: 250 },
    { field: 'Telefone', headerText: 'Telefone', allowSorting: true, width: 150 },
    { field: 'Login', headerText: 'Login', allowSorting: true, width: 120 },
    {
      field: 'Perfil',
      headerText: 'Perfil',
      allowSorting: true,
      width: 120,
      valueAccessor: (field, data) => (data as any).Perfil == 1 ? 'Super' : (data as any).Perfil == 2 ? 'Administrador' : 'Usuário'
    },
    {
      field: "dataAlteracaoStr",
      type: "string",
      headerText: "Ult. Mod.",
      allowSorting: true,
      sortComparer: (a: string, b: string) => {
        return moment(a, 'DD/MM/YYYY HH:mm').diff(moment(b, 'DD/MM/YYYY HH:mm'));
      }
    },
    {
      field: "UsuarioAlteracaoDesc",
      headerText: "Resp. Mod.",
      type: "string",
      allowSorting: true,
    },
    {
      field: 'Ativo',
      headerText: 'Status',
      width: 100,
      allowSorting: true,
      disableHtmlEncode: false,
      valueAccessor: (_field: string, _data: any): any => {
        return this.badgeStatusUsuario(_data.Ativo);
      }
    }
  ];

  // tradução
  USUARIO_ALTERADO: string = 'Usuário alterado!';
  USUARIO_CADASTRADO: string = 'Usuário cadastrado!';
  DELETAR: string = 'Deletar';
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
  CANCELAR: string = 'Cancelar';
  SIM: string = 'Sim';
  USUARIO_DELETADO: string = 'Usuário deletado!';


  constructor(private usuarioService: UsuarioService,
    private empresaService: EmpresaService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private toasty: CustomToastyService,
    private translate: TranslateService,
    private utils: UtilsService,
    public masks: MasksService) {
    this.route.params.subscribe(res => {
      this.id = res.id;
    });
  }

  ngOnInit() {
    this.inserindo = this.router.url.search("inserir") > 0;
    if (this.id > 0)
      this.inserindo = true;
    else {
      this.listarUsuarios();
      this.configurarGrid();
    }
  }


  configurarTraducao() {
    this.USUARIO_ALTERADO = this.translate.instant('USUARIO_ALTERADO');
    this.USUARIO_CADASTRADO = this.translate.instant('USUARIO_CADASTRADO');
    this.DELETAR = this.translate.instant('DELETAR');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.SIM = this.translate.instant('SIM');
    this.USUARIO_DELETADO = this.translate.instant('USUARIO_DELETADO');
  }

  configurarGrid(): void {
    if (window.innerHeight <= 1000) this.gridPageSettings.pageSize = 20;
    else this.gridPageSettings.pageSize = 40;
    this.ajustarTamanhoGrid();
  }

  ajustarTamanhoGrid(): void {
    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement;
      const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement;
      const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement;
      const title = document.querySelector('app-usuario h5.titulo') as HTMLElement;
      const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement;

      if (!navbar || !toolbar || !title) return;

      const groupdropareaHeight = groupdroparea ? groupdroparea.offsetHeight : 0;
      const pagerHeight = pager ? pager.offsetHeight : 0;

      const altura = window.innerHeight - navbar.offsetHeight - groupdropareaHeight - toolbar.offsetHeight - title.offsetHeight - pagerHeight - 70;
      this.gridHeight = `${altura}px`;
    }, 100);
  }

  listarUsuarios() {
    this.carregando = true;
    this.usuarioService.getTodosUsuarios().subscribe(
      res => {
        this.usuarios = res.map(u => Object.assign(new Usuario(), u));
        this.auxUsuarios = res.map(u => Object.assign(new Usuario(), u));
        this.carregando = false;
      },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      });
  }

  excluir() {
    var usuarios = this.gridUsuarios.getSelectedRecords();
    if (usuarios.length <= 0) {
      this.utils.handleWarning("Selecione um usuário para prosseguir!");
      return;
    }
    if (usuarios.length > 1) {
      this.utils.handleWarning("Selecione apenas um usuário para prosseguir!");
      return;
    }
    Swal.fire({
      title: this.DELETAR + ' ' + usuarios[0].Nome + '?',
      text: this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (willDelete.dismiss) {

      } else {
        this.carregando = true;
        this.usuarioService.deleteUsuario(usuarios[0].Id).subscribe(
          res => {
            this.utils.handleSuccess(this.USUARIO_DELETADO);
            this.listarUsuarios();
            this.carregando = false;
          },
          err => {
            this.utils.getErro(err);
            this.carregando = false;
          });
      }
    });
  }

  save(form: any) {
    this.configurarTraducao();
    if (!form.valid) {
      this.isSubmit = true;

      this.carregando = true;

      if (this.objSelecionado.Id > 0)
        this.usuarioService.putUsuario(this.objSelecionado.Id, this.objSelecionado).subscribe(
          res => {
            this.utils.handleSuccess(this.USUARIO_ALTERADO);
            this.carregando = false;
          },
          err => {
            this.utils.getErro(err);
            this.carregando = false;
          });
      else
        this.usuarioService.postUsuario(this.objSelecionado).subscribe(
          res => {
            this.utils.handleSuccess(this.USUARIO_CADASTRADO);
            this.carregando = false;
          },
          err => {
            this.utils.getErro(err);
            this.carregando = false;
          });



    }
    if (this.objetosSelecionados.length > 1) {
      this.utils.handleWarning("Selecione apenas um usuário para prosseguir!");
      return;
    }

    Swal.fire({
      title: 'Excluir ' + this.objetosSelecionados[0].Nome + '?',
      text: 'Se excluir, esta ação não poderá ser desfeita!',
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (willDelete.dismiss) {

      } else {
        this.carregando = true;
        this.usuarioService.deleteUsuario(this.objSelecionadoId).subscribe(
          res => {
            this.utils.handleSuccess(this.USUARIO_DELETADO);
            this.listarUsuarios();
            this.carregando = false;
          },
          err => {
            this.utils.getErro(err);
            this.carregando = false;
          });
      }
    });
  }

  novo() {
    this.router.navigate([`/cadastros/usuario/inserir`]);
  }

  cellDoubleClicked(event) {
    console.log('event.Id',    event.Id);
    this.editar(event.Id);
  }

  onCellClicked(row) {
    this.objSelecionadoId = row.Id;
    this.objSelecionado = row;
  }

  selectionChanged(event) {
    this.objetosSelecionados = event;
  }

  editar(id: number = null) {
    if(id == null) {
      var usuarios = this.gridUsuarios.getSelectedRecords();
      if (usuarios.length <= 0) {
        this.utils.handleWarning("Selecione um usuário para prosseguir!");
        return;
      }
      if (usuarios.length > 1) {
        this.utils.handleWarning("Selecione apenas um usuário para prosseguir!");
        return;
      }
      id = usuarios[0].Id;
    }


    this.router.navigate(['/cadastros/usuario/' + id]);
  }

  acao(acao: string) {
    switch (acao) {
      case "Editar":
        this.editar();
        break;
      case 'Permissões Usuário':
        var usuarios = this.gridUsuarios.getSelectedRecords();
        if (usuarios.length <= 0) {
          this.utils.handleWarning("Selecione um usuário para prosseguir!");
          break;
        }
        if (usuarios.length > 1) {
          this.utils.handleWarning("Selecione apenas um usuário para prosseguir!");
          break;
        }
        this.abrirModalCopiaPermissao();
        break;
      case 'Permissões Transações':
        var usuarios = this.gridUsuarios.getSelectedRecords();
        if (usuarios.length <= 0) {
          this.utils.handleWarning("Selecione um usuário para prosseguir!");
          break;
        }
        if (usuarios.length > 1) {
          this.utils.handleWarning("Selecione apenas um usuário para prosseguir!");
          break;
        }
        this.abrirModalCopiaPermissaoTransacao();
        break;
      default:
        break
    }
  }

  abrirModalCopiaPermissao() {
    this.ModalCopiaPermissao.show();
  }

  fecharModalCopiaPermissao() {
    this.selectedId = null;
    this.ModalCopiaPermissao.hide();
  }

  onCopiarPermissao(id) {
    var usuarios = this.gridUsuarios.getSelectedRecords();
    let usuario = usuarios[0];
    const permissao = this.usuarios.filter(u => u.Id == id).map(e => e.PermissaoUsuario)[0];
    permissao.UsuarioId = id;
    usuario.PermissaoUsuario = permissao;
    this.usuarioService.putUsuario(usuarios[0].Id, usuario).subscribe(res => {
      this.utils.handleSuccess('Permissão copiada');
    }, err => this.utils.getErro(err));
    this.fecharModalCopiaPermissao();
  }

  abrirModalCopiaPermissaoTransacao() {
    this.ModalCopiaPermissaoTransacao.show();
  }

  fecharModalCopiaPermissaoTransacao() {
    this.selectedId = null;
    this.ModalCopiaPermissaoTransacao.hide();
  }

  onCopiarPermissaoTransacao(id) {
    var usuarios = this.gridUsuarios.getSelectedRecords();
    let usuario = usuarios[0];
    const usuarioId = usuarios[0].Id;

    usuario.permissaoUsuarioTransacaos.forEach(p => {
      this.usuarioService.deletePermissaoUsuarioTransacaos(p.Id, p.UsuarioId).subscribe(res => {

      }, err => this.utils.getErro(err));
    })

    let permissao = this.usuarios.filter(u => u.Id == id).map(e => e.permissaoUsuarioTransacaos)[0];

    setTimeout(() => {
      permissao.forEach(p => {
        var aux = p;
        aux.Id = 0;
        aux.UsuarioId = usuarioId;
        this.usuarioService.postPermissaoUsuarioTransacaos(usuarioId, aux).subscribe(res => {
          this.utils.handleSuccess(`Permissão transação ${p.NomeTransacao} copiada com sucesso!`);
        }, err => this.utils.getErro(err));
      })
    }, 1500);

    this.listarUsuarios();
    this.fecharModalCopiaPermissaoTransacao();
  }

  badgeStatusUsuario(ativo: boolean): string {
    if (ativo) {
      return '<span class="badge badge-light-success custom-badge-grid">Ativo</span>';
    } else {
      return '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>';
    }
  }

  ValidarSelectApenasUm(): boolean {
    var variedades = this.gridUsuarios.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (variedades.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var variedades = this.gridUsuarios.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  confirmaDuplicar(): void {
    var variedades = this.gridUsuarios.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os usuarios selecionados serão duplicadas!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar usuarios",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(variedades);
      }
    });
  }

  duplicar(locais: Usuario[]): void {
    this.duplicando = true
    this.usuarioService.duplicar(locais.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess("Usuarios duplicados com sucesso")
        this.listarUsuarios();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }


  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais) return
    var lista = this.gridUsuarios.getSelectedRecords();
    if (lista.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    const todasInativas = lista.every(v => v.Ativo === false);
    const algumaInativa = lista.some(v => v.Ativo === false);

    if (todasInativas) {
      this.utils.handleWarning("Todos os lusuarios selecionados já estão inativos");
      return;
    }

    let texto = "Os usuarios selecionados serão inativados!";
    if (algumaInativa) {
      texto += '<br> Alguns usuarios já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar usuarios",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(lista);
      }
    });

  }

  inativar(lista: Usuario[]): void {
    this.inativando = true
    this.usuarioService.inativar(lista.map(p => p.Id))
      .subscribe((res) => {
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const item = lista.find(v => v.Id.toString() === id);
            const nomeItem = item ? item.Nome : `ID ${id}`;
            erros.push(`<b>${nomeItem}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao Inativar Usuários',
            html: `Os seguintes Usuários não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } if (lista.filter(v => v.Ativo === false).length > 0) {
          const erros: string[] = [];
          lista.filter(v => v.Ativo === false).forEach(item => {
            const nomeItem = item ? item.Nome : `ID ${item.Id}`;
            erros.push(`<b>${nomeItem}</b>: Já está inativo.`);
          });
          Swal.fire({
            title: 'Erro ao Inativar Usuários',
            html: `os seguintes usuários não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        }
        else {
          this.utils.handleSuccess("Usuários inativados com sucesso");
        }
        this.listarUsuarios();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }

  finalizarSave(): void {
    this.listarUsuarios();
  }

  confirmRemover() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirLocalEstoque'))
      return;

    this.CANCELAR = this.translate.instant("CANCELAR");
    this.SIM = this.translate.instant("SIM");
    var lista = this.gridUsuarios.getSelectedRecords();
    if (lista.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os usuarios selecionados serão excluidos, esta ação não poderá ser desfeita!",
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.remover(lista)
    });
  }

  remover(lista: Usuario[]) {
    this.removendo = true;
    this.usuarioService.deleteLista(lista.map(p => p.Id)).subscribe(
      res => {
        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais variedades falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const variedade = lista.find(v => v.Id.toString() === id);
            const nomeVariedade = variedade ? variedade.Nome : `ID ${id}`;
            erros.push(`<b>${nomeVariedade}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir usuarios',
            html: `Os seguintes usuarioss não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          this.utils.handleSuccess("Usuarios excluídos com sucesso");
        }

        this.listarUsuarios();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });

  }

  filtrar() {
    this.usuarios = this.auxUsuarios.filter(x =>
      x.Nome.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
    );
  }
}
